// extracted by mini-css-extract-plugin
export var button = "styles-module--button--HFPlR";
export var file_text = "styles-module--file_text--SzHYw";
export var icon = "styles-module--icon--fRuDu";
export var input = "styles-module--input--RFgl3";
export var label = "styles-module--label--yfeE1";
export var outlined = "styles-module--outlined--ybAyU";
export var wrapper = "styles-module--wrapper--BGGQv";